import { z } from "zod";
import { ValidationError } from "../../domain/errors";

export class ValidationUtils {
  static validate<T>(
    schema: z.ZodSchema<T>,
    data: unknown,
    context?: string
  ): T {
    try {
      return schema.parse(data);
    } catch (error) {
      if (error instanceof z.ZodError) {
        const firstError = error.issues[0];
        const field = firstError.path.join(".");
        const message = `${context ? `${context}: ` : ""}${firstError.message}`;

        throw new ValidationError(message, field);
      }
      throw error;
    }
  }

  static validateAsync<T>(
    schema: z.ZodSchema<T>,
    data: unknown,
    context?: string
  ): Promise<T> {
    return new Promise((resolve, reject) => {
      try {
        const result = this.validate(schema, data, context);
        resolve(result);
      } catch (error) {
        reject(error);
      }
    });
  }

  static safeValidate<T>(
    schema: z.ZodSchema<T>,
    data: unknown
  ): { success: true; data: T } | { success: false; error: ValidationError } {
    try {
      const result = this.validate(schema, data);
      return { success: true, data: result };
    } catch (error) {
      if (error instanceof ValidationError) {
        return { success: false, error };
      }
      return {
        success: false,
        error: new ValidationError("Erro de validação desconhecido"),
      };
    }
  }
}

export const commonSchemas = {
  email: z.email("Email inválido"),
  password: z.string().min(8, "Senha deve ter no mínimo 8 caracteres"),
  uuid: z.uuid("ID inválido"),
  phone: z.string().regex(/^\(\d{2}\)\s\d{4,5}-\d{4}$/, "Telefone inválido"),
  cpf: z.string().regex(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, "CPF inválido"),
  name: z
    .string()
    .min(2, "Nome deve ter no mínimo 2 caracteres")
    .max(100, "Nome muito longo"),
  date: z.string().refine((date) => !isNaN(Date.parse(date)), "Data inválida"),
};
